export function labelForType(type: string): string {
  switch (type) {
    case "MACHINE":
      return "Máquina";
    case "EQUIPMENT":
      return "Equipamento";
    case "SENSOR":
      return "Sensor";
    case "SCALE":
      return "Balança";
    case "CONTROL_POINT":
      return "Ponto de controle";
    case "INSPECTION":
      return "Inspeção";
    case "HUMAN_STEP":
      return "Etapa humana";
    case "GROUP":
      return "Agrupamento";
    case "START":
      return "Início";
    case "END":
      return "Fim";
    default:
      return type;
  }
}
